<div *ngIf="isLoading" class="cdc-loading-overlay">
  <mat-spinner class="cdc-loading-spinner"></mat-spinner>
  <div class="cdc-loading-text">{{ 'Loading' | translate }}</div>
</div>

<mat-toolbar class="admin-toolbar">
  <span [matTooltip]="version">CDC</span>

  <a class="btn btn-primary link-btn" (click)="confirmNavigation('/admin/offers')" [ngClass]="{ 'active': isActive('/admin/offers') }">
    {{ 'Offers' | translate }}
  </a>
  <a class="btn btn-primary link-btn" (click)="confirmNavigation('/admin/pages')" [ngClass]="{ 'active': isActive('/admin/pages') }">
    {{ 'Pages' | translate }}
  </a>
  <span class="spacer"></span>

  <button mat-icon-button matTooltip="{{ 'More' | translate }}" [matMenuTriggerFor]="morePage">
    <mat-icon class="m-0">more_vert</mat-icon>
  </button>
  <mat-menu class="more-menu" #morePage="matMenu" xPosition="before">
    <button class="more-menu-item" mat-menu-item (click)="clearCache()">
      <mat-icon>cleaning_services</mat-icon>
      <span>{{'Clear cache' | translate}}</span>
    </button>
    <button class="more-menu-item" mat-menu-item (click)="onExportStats()">
      <mat-icon>file_download</mat-icon>
      <span>{{'Export stats' | translate}}</span>
    </button>
  </mat-menu>

  <button mat-icon-button (click)="confirmNavigation('logout')">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>

<div class="content main-content">
  <router-outlet></router-outlet>
</div>

